export default {
      id: "up-right-from-square-solid-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#up-right-from-square-solid",
      toString: function () {
        return this.url;
      }
    }